import { useEffect, useState } from "react";

const useControlKeyPress = (targetKey) => {
  // State for keeping track of whether key is pressed
  const [keyPressed, setKeyPressed] = useState(false);
  // If pressed key is our target key then set to true
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const downHandler = ({ key, ctrlKey }) => {
    if (ctrlKey && key === targetKey) {
      setKeyPressed(true);
    }
  };
  // If released key is our target key then set to false
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const upHandler = ({ key, ctrlKey }) => {
    if (ctrlKey && key === targetKey) {
      setKeyPressed(false);
    }
  };
  // Add event listeners
  useEffect(() => {
    window.addEventListener("keydown", downHandler);
    window.addEventListener("keyup", upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener("keydown", downHandler);
      window.removeEventListener("keyup", upHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return keyPressed;
};

export default useControlKeyPress;
